import { render, staticRenderFns } from "./DataNotFound.vue?vue&type=template&id=549a9842&scoped=true"
import script from "./DataNotFound.vue?vue&type=script&lang=js"
export * from "./DataNotFound.vue?vue&type=script&lang=js"
import style0 from "./DataNotFound.vue?vue&type=style&index=0&id=549a9842&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549a9842",
  null
  
)

export default component.exports